import {
    Box,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    Stack,
    Select,
    Flex,
    Text,
    Button,
    Image
} from "@chakra-ui/react";
import React from "react";
import Colors from "../../../assets/colors/Colors";
import {
    GrubFormButton,
    GrubInput,
    GrubTitleText,
    GrubProgress,
    GrubErrorMessage,
    GrubAlert
} from "../../../components/index";
import call from "../../../assets/images/call.svg";
import { WithRouter } from "../../../navigators/WithRouter";
import BackIconButton from "../components/BackIconButton";
import { usePhoneSignUp } from "../hooks/usePhoneSignUp";
import warnignIcon from "../../../assets/images/Ellipse2.svg";
import * as Constants from "../../../constants/Constants";
// import PhoneVerification from "./PhoneVerification";

const PhoneSignUp = (props) => {
    const [
        handleKeyDown,
        formik,
        buttonDisable,
        handleSubmit,
        isSubmittingRef,
        // handleBackButton,
        showVerification,
        setShowVerification,
        countryCodes,
        selectedCountryCode,
        setCountryCodeHandler,
        loading,
        phoneSignUpOpen,
        handlePhoneChange,
        formatPhoneNumber,
        changeToSignUpHandler,
        isFocused,
        errorMessage,
        phoneRef,
        phoneUpdate,
        handleFocus
    ] 
    // = usePhoneSignUp(props);
    = usePhoneSignUp({
        ...props,
        onOTPSent: () => setShowVerification(true)
    });
    
    return (
        <>
        <Modal
            isOpen={props.isOpen && !showVerification}
            onClose={() => setShowVerification(false)}
            size="sm"
            isCentered
            initialFocusRef={phoneRef}
            finalFocusRef={null}
            returnFocusOnClose={false} 
            closeOnEsc={false}
            closeOnOverlayClick={false}
        >
            <ModalOverlay />
            <ModalContent
                marginLeft="1rem" 
                marginRight="1rem" 
                borderRadius="0.63rem">
                {loading && (
                    <GrubProgress />
                )}
                <ModalBody
                    pl={{ base: "1.5rem", md: "2.56rem" }}
                    pr={{ base: "1.5rem", md: "2.56rem" }}
                    pb={{ base: "4.13rem", md: "4.13rem" }}
                    pt={{ base: "1.88rem", md: "1.88rem" }}
                >
                    <BackIconButton
                        iconButton={true}
                        onClick={(e) => {
                            e.preventDefault();
                            if(phoneSignUpOpen){
                                changeToSignUpHandler();
                            }
                            else{
                                props.handleBackButton(false);
                            }
                        }}
                    />
                    <GrubTitleText
                        isLabelText={true}
                        fontSize="1.125rem"
                        color={Colors.posTextInfo}
                        name={phoneSignUpOpen ? "Sign Up" : phoneUpdate ? "Update Phone Number" : "Sign In"}
                    />
                    {/* <GrubTitleText
                        isLabelText={true}
                        color={Colors.primeTaxInfo}
                        fontSize="0.875rem"
                        name={"Have an existing account?"}
                        cursor="pointer"
                        // onClick={handleBackButton}
                    /> */}
                    {phoneSignUpOpen && !phoneUpdate ? (
                    <Button
                        variant="link"
                        onClick={(e) => {
                            e.preventDefault();
                            changeToSignUpHandler();
                        }}
                        fontStyle="normal"
                        fontWeight={300}
                        fontSize="0.875rem"
                        color={Colors.primeTaxInfo}
                    >
                        Have an existing account?
                    </Button>
                    ) : (
                        !phoneUpdate && (
                            <Button
                                variant="link"
                                onClick={(e) => {
                                    e.preventDefault();
                                    changeToSignUpHandler();
                                }}
                                fontStyle="normal"
                                fontWeight={300}
                                fontSize="0.875rem"
                                color={Colors.primeTaxInfo}
                            >
                                Don't have an account?
                            </Button>
                        )
                    )}
                    <Stack spacing={2} mt={{ base: "1.5rem", md: "1.5rem" }}>

                        {/* <GrubTitleText
                            isLabelText={true}
                            color={Colors.posTextInfo}
                            fontSize="0.875rem"
                            name={"Enter your Mobile Number"}
                        />
                        <GrubTitleText
                            isLabelText={true}
                            color={Colors.grubHeaderColor}
                            fontSize="0.75rem"
                            name={"Please confirm valid mobile number"}
                        /> */}
                        <Box mb={4}>
                            <GrubTitleText
                                isLabelText={true}
                                fontSize="0.9375rem"
                                color={Colors.posTextInfo}
                                name={"Enter your Mobile Number"}
                            />
                            <GrubTitleText
                                isLabelText={true}
                                fontSize="0.9375rem"
                                color="#01004866"
                                fontWeight="300"
                                name={"Please confirm valid mobile number"}
                            />
                        </Box>
                        <Flex align="center" mt={2}>
                        <Box display="inline-block" minW="7rem" maxW="12rem">
                            <Select
                                value={selectedCountryCode.label}
                                width="auto"
                                mr={1}
                                fontSize="0.875rem"
                                bg="white"
                                border="1px solid #E2E8F0"
                                borderRadius="0.375rem"
                                height="2.5rem"
                                // paddingInlineStart="0.5rem"
                                paddingInlineEnd="0.3rem"
                                onChange={(e) => {
                                    const country = countryCodes.find(c => c.label === e.target.value);
                                    setCountryCodeHandler(country);
                                }}
                            >
                                {countryCodes.map((country) => (
                                    <option 
                                        key={`${country.code}-${country.country}`} 
                                        value={country.label}
                                    >
                                        {country.label}
                                    </option>
                                ))}
                            </Select>
                        </Box>
                        <GrubInput
                            id="phone"
                            ref={phoneRef}
                            placeholder={"Phone Number"}
                            handleInputChange={handlePhoneChange}
                            inputValue={formatPhoneNumber(formik.values.phone || "")}
                            handleBlur={(e) => {
                                setTimeout(() => {
                                    formik.handleBlur(e)
                                }, Constants.TIMEOUT_DELAY); // Delay execution to allow click event to register first
                            }}
                            onFocus={handleFocus}
                            posInputGroup={true}
                            autoFocus={isFocused}
                            darkPlaceholder={true}
                            onKeyDown={handleKeyDown}
                            background={Colors.posviewbgcolor}
                            inputType={"text"}
                            inputError={
                                formik.touched.phone && formik.errors.phone
                            }
                        >
                            <Image src={call} width={"0.99rem"} />
                        </GrubInput>
                        </Flex>
                        {/* {formik.touched.phone && formik.errors.phone && (
                            <GrubTitleText
                                isErrorText={true}
                                color={Colors.posCancleButtonRed}
                                name={formik.errors.phone}
                            />
                        )} */}
                        {formik.touched.phone &&
                            formik.errors.phone && (
                                <GrubAlert
                                    width={"100%"}
                                    alertStatus={"error"}
                                    alertTitle={""}
                                    image={warnignIcon}
                                    bg={Colors.errorsign}
                                    color={Colors.orangeButton}
                                    alertDescription={
                                        formik.errors.phone
                                    }
                                />
                        )}
                    </Stack>
                    {/* <Button
                        variant="link"
                        onClick={props.LoginViaEmail}
                        fontStyle="normal"
                        fontWeight={300}
                        fontSize="0.75rem"
                        lineHeight="0.94rem"
                        letterSpacing="-0.01rem"
                        color={Colors.primeTaxInfo}
                    >
                        Login via email & password
                    </Button> */}
                    {errorMessage?.error && errorMessage?.message?.length > 0 && (
                        <GrubErrorMessage
                            errorMessage={errorMessage.message}
                            width={"auto"}
                        />
                    )}
                    <Box mt={{ base: "2.44rem", md: "2.44rem" }}>
                        <GrubFormButton
                            isDisabled={buttonDisable 
                                // || !formik.values.phone || formik.errors.phone
                            }
                            bg="#1A1552"
                            buttonsubmit={"Continue"}
                            width={"full"}
                            onClick={(e) => {
                                e.preventDefault();
                                if (!formik.values.phone || formik.errors.phone) {
                                    formik.setTouched({
                                        phone: true
                                    });
                                    return;
                                }
                                handleSubmit();
                            }}
                        />
                    </Box>
                    {!phoneSignUpOpen && !phoneUpdate && (
                    <Flex alignSelf="center" mt={'1rem'}>
                        <Button
                            variant="link"
                            onClick={(e) => {
                                e.preventDefault();
                                props.LoginViaEmail();
                            }}
                            fontStyle="normal"
                            fontWeight={300}
                            fontSize="0.875rem"
                            color={Colors.primeTaxInfo}
                        >
                            Login via email & password
                            </Button>
                    </Flex>
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
        {/* <PhoneVerification
            isOpen={props.isOpen && showVerification}
            phoneNumber={`${formik.values.phone}`}
            onBack={() => setShowVerification(false)}
            onVerify={(otp) => {
                // Handle OTP verification
            }}
        /> */}
        </>
    );
};

export default WithRouter(PhoneSignUp); 